<template>
	 <div class="index_bg">
	 	
  <div class="wimg-c" v-if="info"><img :src="info.subscribe_code_img" width="100%"></div>
  <div class="time">
    <p> 投票已结束，请前往抽奖</p>
    <p v-if="time>0" v-show="false"><b>投票倒计时：</b><van-count-down :time="time" format="DD 天 HH 时 mm 分 ss 秒" /></p>
    <p v-show="false"><b>投票须知：</b>{{info.subscribe_desc}}</p>
  </div>
  <div class="number">
    <van-row>
      <van-col span="8">
        <p>{{people_num}}</p>
        <p>作品数量</p>
      </van-col>
      <van-col span="8" class="border-van">
        <p>{{vote_num}}</p>
        <p>总票数</p>
      </van-col>
      <van-col span="8">
        <p>{{total_number}}</p>
        <p>浏览人数</p>
      </van-col>
    </van-row>
  </div>
  <div class="search">
    <van-search
  v-model="keyword"
  placeholder="请输入搜索编号/作品名称"
  @search="onSearch"
>
</van-search>
  </div>
  <div v-if="groups.length >0">
  <div class="groups" >
    <van-button type="default" :class="group_hover == index?'group_button_hover':'group_button'" :color="group_hover == index?'#e4485e':'#f7e6e7'" v-for="(item, index) in groups" @click="clickGroup(index)">{{item}}</van-button>
  </div>
  <div class="list" v-for="(val, index) in list" v-show="group_hover == index">
    <van-checkbox-group v-model="result[index]" change="selectVote">
      <van-grid :column-num="2" :border="false">
        <van-grid-item class="list-li" v-for="(item, i) in val">
          <div class="badge">{{i+1}}</div>
          <van-image :src="item.thumb" v-if="index > 0 && i<4 && item.thumb"  @click="JumpUrl(item)"/>
          <van-image :src="item.thumb" v-else-if="item.thumb" lazy-load @click="JumpUrl(item)"/>
          <p @click="JumpUrl(item)">{{item.name}}</p>
          <p class="vote_num"><van-checkbox  @click="clickCheckBox" :name="item.id" checked-color="#C81B1D"><span class="vote_num">{{item.vote_num}}</span></van-checkbox></p>
        </van-grid-item>
      </van-grid>
    </van-checkbox-group>
   </div>
  </div>
  <div v-else>
  <div class="list">
    <van-checkbox-group v-model="result" change="selectVote">
      <van-grid :column-num="2" :border="false">
        <van-grid-item class="list-li" v-for="item in list">
          <div class="badge">{{item.listorder}}</div>
          <van-image v-if="item.thumb" :src="item.thumb" lazy-load @click="JumpUrl(item)"/>
          <p @click="JumpUrl(item)">{{item.name}}</p>
          <p class="vote_num"><van-checkbox  @click="clickCheckBox" :name="item.id" checked-color="#C81B1D"><span class="vote_num">{{item.vote_num}}</span></van-checkbox></p>
        </van-grid-item>
      </van-grid>
    </van-checkbox-group>
   </div>
  </div>

  <div class="tagpos">
    <van-tag color="#7232dd" style="display: block;" @click="clearSelect">清除</van-tag>
    <van-tag color="#7232dd" style="display: block; margin-top: 10px;">已选({{this.result.length}})</van-tag>
  </div>


   <Bottom :active="0"></Bottom>
	</div>
</template>

<script>
import { Dialog } from 'vant';
import { getIndex, addVote } from '../api/vote'
import Bottom from './bottom'
//http://oss.ahxmgk.com/yun/uploads/image/2022/05/29/9c4f40ca90e6522befb4e3bd7274b540.png
export default {
  name: 'Index',
  components: {
    Bottom
  },
  watch: {
    result(val, oldval){
      console.log(val)
      // console.log(this.info)
      let nval = val
      let noldval = oldval
      if(!nval || !noldval) return
      if(this.info.template_name) {
        nval = val[this.group_hover]
        noldval = oldval[this.group_hover]
      }

      // console.log(noldval.length)
      if(nval.length > this.info.user_number &&  noldval.length >= this.info.user_number) {
        this.$dialog.alert({
              message: '最多只能选择' + this.info.user_number + '名',
        })
        // this.result = noldval
        return
      }
      console.log(nval)
      if(nval.length == this.info.user_number) {
        this.selectVote()
        return
      }
    }
  },
  data () {
    return {
    	info: this.$store.state.acc,
      user: this.$store.state.user,
      show: false,
      list: [],
      time: 0,
      vote_num: 0,
      people_num: 0,
      total_number: this.$store.state.acc.total_number,
      result: [],
      vote_cache_key: '___vote_cache_key____',
      groups: [],
      group_hover: 0,
      keyword: '',
      allList: []
    }
  },
  created(){
  	getIndex().then(res=> {
      this.list = res.list

      //如果分组则直接走分组
      if(this.info.template_name) {
        this.listGroup(res.list)
      }else{
        this.list = res.list
        this.allList = (this.list)
      }
      this.vote_num = res.vote_num
      this.people_num = res.people_num
      this.total_number = res.total_number
      this.setTime(res.end_time)
  	})
    let result = localStorage.getItem(this.vote_cache_key)
    if(result)this.result = JSON.parse(result)
  },
  methods: {
    setTime(end_time){
      let that  = this
      setTimeout(function(){
         //处理时间
        let date1 = new Date().getTime()
        that.time = (end_time - date1)
      }, 1000)
    },
    onSearch(val){
      var list = []
      console.log(val)
      for(var i in this.allList) {
        console.log(this.allList[i]['listorder'] ==val)
        if(val == this.allList[i]['listorder']) {
          list = [this.allList[i]]
          break
        }
        if(this.allList[i]['name'].indexOf(val)>=0) {
          list[list.length] = this.allList[i]
        }
      }
      
      if(list.length ==0){
        this.$toast( '暂无数据' )
        list = this.allList
      }
      this.list = list
    },
    clickCheckBox(){
      
    },
    clearSelect(){
      this.$dialog.alert({
          title: '提示',
          message: '你确定要取消所选吗？',
          showCancelButton: true
        }).then((res) => {
          if(res) {
            this.result = []
          }
        })
    },
    selectVote() {
      localStorage.setItem(this.vote_cache_key, JSON.stringify(this.result))
      let result = this.result
      if(this.info.template_name) {
        result = this.result[this.group_hover]
      }
      //提交投票
      if(result.length == this.info.user_number) {
        this.$dialog.alert({
          title: '提示',
          message: '已经选择' + result.length + '选手，需要提交投票吗？',
          showCancelButton: true
        }).then(() => {
          this.$toast.loading({
            message: '加载中...',
            forbidClick: false,
            loadingType: 'spinner',
            duration: 10000
          });
          addVote({result, group_hover: this.group_hover}).then(res=> {
            this.$toast.clear()
            localStorage.removeItem(this.vote_cache_key)
            this.$dialog.alert({
                message: res.msg,
            }).then(res=> {
              this.result = []
              // this.$router.push({name: 'DatiChoujiang'})
            })
          })
        })
      }
      console.log(this.result)
    },
    listGroup(list){
      this.groups = this.info.template_name.split(',')
      if(this.groups.length ==0)return
      let data = []
      list.forEach(res=> {
        let key = this.groups.indexOf(res.group_name);
        if(key >=0) {
          if(!data[key]) {
            data[key] = []
          }
          data[key].push(res)
        }
      })
      this.list = data
    },
    clickGroup(index){
      this.group_hover = index
    },
    JumpUrl(item){
      this.$router.push({name: 'Content', params: {id: item.id}})
    }
  }
};

</script>
<style scoped>
.tagpos{
  position: fixed;
    top: 60%;
    z-index: 11111111;
    right: 0;
}
.list{ width: 90%; margin: 30px auto; background: #fff;  border-radius: 10px;  margin-bottom: 100px;}
.list-li, .list-li .van-grid-item__content.van-grid-item__content--center{ background: none; }
.list .badge{position: absolute; left: 8px; width: 25px; height: 25px; background: #5d9d22; top: 16px; z-index: 1; line-height: 25px; color: #fff;text-align: center; border-bottom-right-radius: 20px;}
.list p{line-height: 25px; margin-top: 5px; font-size: 16px}
.list p.vote_num{font-size: 18px; color: #fa993a;}
.time{ background: #fff; width: 90%; margin: 20px auto; border-radius: 10px; line-height: 40px; font-size: 18px; padding-left: 10px; padding-top: 10px;}
.time p b{color: #000;}
.van-count-down{ display: inline; }
.van-count-down{line-height: 40px; font-size: 18px;}
.number{width: 90%; margin: 30px auto; text-align: center; color: #fff;}
.number p{ margin-bottom: 10px }
.border-van{border-left: 1px solid #fff;border-right: 1px solid #fff; }


.wimg-c{width: 100%; text-align: center;}
.index_bg{
  margin-bottom: 100px;
  background: #C81B1D;
  overflow: hidden;
}
.jieshaos{ position: absolute; top: 10%; right: 0px; width: 10%; }
.jieshao{ position:absolute; bottom: 7%; width:100%; text-align: center; }
.jieshaod{ position:absolute; bottom: 17%; width:100%; text-align: right; }

.groups{text-align: center;}
.groups button{margin: 0 5px}
.group_button span{color:#323233}
.group_button_hover span{color: #fff;}
.van-search{
  background: none;
}
</style>